document.addEventListener("DOMContentLoaded", function () {
  const excludedPaths = ['/pages/about-us', '/pages/store-info', '/pages/contact', '/pages/shopguide', '/pages/tradelaw', '/pages/privacy', '/account', '/cart' ];
  const currentPath = window.location.pathname;
  const hasClosedBanner = sessionStorage.getItem("hidePopupBanner");

  if (!excludedPaths.includes(currentPath) && !hasClosedBanner) {
    const banner = document.getElementById("custom-popup-banner");

    if (banner) {
      const slides = banner.querySelectorAll(".popup-slide");
      const totalSlides = slides.length;

      if (totalSlides === 0) {
        banner.remove();
        return;
      }

      banner.style.display = "block";

      const closeBtn = document.getElementById("popup-close-btn");
      closeBtn.addEventListener("click", function () {
        sessionStorage.setItem("hidePopupBanner", "true");
        banner.remove();
      });

      let currentIndex = 0;

      const showSlide = (index) => {
        slides.forEach((slide, i) => {
          slide.classList.toggle("active", i === index);
        });
      };

      showSlide(currentIndex);

      if (totalSlides > 1) {
        setInterval(() => {
          currentIndex = (currentIndex + 1) % totalSlides;
          showSlide(currentIndex);
        }, 5000); // 4秒ごとに切り替え
      }
    }
  }
});


